import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class PartyService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/party';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }
    
    getAgentList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getAgentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPurchaseAgentList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getPurchaseAgentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    getLineList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getLineList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    getPartyList(partyData: any): Promise<any[]> {
       const url = `${this.Url}/getPartyList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getagentDetList(partyData: any): Promise<any[]> {
        const url = `${this.Url}/getagentDetList`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    
    getExcelPartyList(partyData: any): Promise<any[]> {
        const url = `${this.Url}/getExcelPartyList`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    editSalesParty(partyData: any): Promise<any[]> {
        const url = `${this.Url}/editSalesParty`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     editPurchaseParty(partyData: any): Promise<any[]> {
        const url = `${this.Url}/editPurchaseParty`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }



    save(partyData: any): Promise<any> {
        const url = `${this.Url}/save`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveParty(partyData: any): Promise<any> {
        const url = `${this.Url}/saveParty`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveagentDet(partyData: any): Promise<any> {
        const url = `${this.Url}/saveagentDet`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    delete(userData: any): Promise<any> {
        const url = `${this.Url}/delete`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    deletePurchaseParty(userData: any): Promise<any> {
        const url = `${this.Url}/deletePurchaseParty`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/party.service.ts